import React, { Component } from "react";
import Switch from "react-switch";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";

class SwitchBtn extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);

    let prop = this.props.accessData;
    let currRights = prop.hasAllowed;

    this.state = {
      accessRights: currRights,
    };
  }

  handleChange() {
    let prop = this.props.accessData;
    let currState = this.state.accessRights;
    customLog(currState);
    const retractURL =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/retractAccessEmail";

    const grantURL =
      "https://us-central1-egeetouchindustrial.cloudfunctions.net/grantAccessEmail";

    const registry = fire
      .database()
      .ref("retractableSharingRegistry")
      .child(prop.senderUID)
      .child(prop.key)
      .child("multiSharingAdmins")
      .child(auth.currentUser.uid);

    registry.update({
      hasAllowed: !currState,
    });

    registry.once("value").then(async (snapshot) => {
      if (snapshot.exists()) {
        const snapshotVal = snapshot.val();

        customLog(snapshotVal);

        const dataToSend = {
          lockSerial: prop.lockSerial,
          email: prop.shareFrom,
          ownerUid: auth.currentUser.uid,
        };

        if (!currState === false) {
          if (!snapshotVal.hasAllowed) {
            fetch(retractURL, {
              method: "POST",
              body: JSON.stringify(dataToSend),
            });
          }
        } else if (!currState === true) {
          if (snapshotVal.hasAllowed) {
            fetch(grantURL, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataToSend),
            });
          }
        }
      }
    });

    this.setState({
      accessRights: !currState,
    });
  }

  render() {
    return (
      <Switch
        onChange={this.handleChange}
        checked={this.state.accessRights}
        id="normal-switch"
      />
    );
  }
}

export default SwitchBtn;
